import { Language } from './config'
import { getQueryParams } from '../connectivity/request'

export const getLocale = (): Language => (getQueryParams()?.locale === Language.fr ? Language.fr : Language.en)
